import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { TechSupportComponent } from "./desktop/d-landing-page/tech-support/tech-support.component";
import { DesktopComponent } from "./desktop/desktop.component";
import { MobileHomeComponent } from "./mobile/home/home.component";
import { ReturnItemComponent } from "./mobile/return-item/return-item.component";
import { LoginPageComponent } from "./mobile/login/login.component";
import { ConfirmReturnComponent } from "./mobile/confirm-return/confirm-return.component";
import { ReturnCreatedComponent } from "./mobile/return-created/return-created.component";
import { LandingPageComponent } from "./mobile/landing-page/landing-page.component";
import { DeliveryOptionsComponent } from "./mobile/delivery-options/delivery-options.component";
import { StartComponent } from "./desktop/d-landing-page/start/start.component";
import { ReturnItemsComponent } from "./desktop/d-landing-page/return-items/return-items.component";
import { ReturnOptionsComponent } from "./desktop/d-landing-page/return-options/return-options.component";
import { ConfirmComponent } from "./desktop/d-landing-page/confirm-return/confirm-return.component";
import { ReturnComponent } from "./desktop/d-landing-page/return/return.component";
import { AppFlowService } from "./shared/services/app-flow/app-flow.service";
import { DesktopScreenRouteGuard } from "./shared/route-guard/desktop-screen-route-guard";
import { MobileScreenRouteGuard } from "./shared/route-guard/mobile-screen-route-guard";
import { AppFlowRouteGuard } from "./shared/route-guard/app-flow-route-guard";
import { NotFoundComponent } from "./shared/components/not-found/not-found.component";
import { TestHomeComponents } from "./shared/components/test-home/test-home.component";
import { LandingPageRouteGuard } from "./shared/route-guard/landing-page-route-guard";
import { clientConfig } from "./shared/constant/app.constant";
import { ReturnOrderRouteResolver } from "./shared/route-resolver/return-order.route-resolver";
import { OrderSelectionRouteGuard } from "./shared/route-guard/order-selection-route-guard";
import { SomethingWrongComponent } from "./shared/components/errors/something-wrong/something-wrong.component";
import { LabelCreatedRouteGuard } from "./shared/route-guard/label-created-route-guard";
import { DeliveryOptionsRouteGuard } from "./shared/route-guard/delivery-options-route-guard";
import { AddItemComponent } from "./shared/components/add-item/add-item.component";
import { MAddItemComponent } from "./mobile/add-item/add-item.component";
import { UpdateAddressComponent } from "./mobile/delivery-options/update-address/update-address.component";
import { UpdateComponent } from "./desktop/d-landing-page/return-options/update-address/update-address.component";
import { RetunOrderLoginComponent } from "./desktop/d-landing-page/retun-order-login/retun-order-login.component";
import { CancelorderComponent } from "./desktop/d-landing-page/cancelorder/cancelorder.component";
import { CancelOriginalReturnRouteGuard } from "./shared/route-guard/cancel-original-return.guard";
import { EditShipmentRouteGuard } from "./shared/route-guard/edit-shipment-route-guard";
import { TechSupportRedirectGuard } from "./shared/route-guard/tech-support-redirect.guard";
import { CustomerServiceCaseComponent } from "./desktop/d-landing-page/customer-service-case/customer-service-case.component";
import { TechSupportRouteGuard } from "./shared/route-guard/tech-support-route-guard";
import { TechSupportResolver } from "./shared/route-resolver/tech-support-resolver";
import { GlobalErrorComponent } from "./shared/components/errors/global-error/global-error.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "m",
    pathMatch: "full",
  },
  {
    path: "d",
    component: DesktopComponent,
    canActivate: [DesktopScreenRouteGuard],
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: TestHomeComponents,
        canActivate: [LandingPageRouteGuard],
      },
      {
        path: "welcome",
        component: StartComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard],
      },
      {
        path: "login",
        component: RetunOrderLoginComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard],
      },
      {
        path: "cancelorder",
        component: CancelorderComponent,
        canActivate: [EditShipmentRouteGuard],
      },
      {
        path: "additems",
        component: AddItemComponent,
        canActivate: [],
      },
      {
        path: "itemselection",
        component: ReturnItemsComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard],
      },
      {
        path: "techsupport",
        component: TechSupportComponent,
        canActivate: [AppFlowRouteGuard, TechSupportRouteGuard],
      },
      {
        path: "shippingoption",
        component: ReturnOptionsComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard, OrderSelectionRouteGuard],
      },
      {
        path: "updateaddress",
        component: UpdateComponent,
      },
      {
        path: "returnconfirm",
        component: ConfirmComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard, OrderSelectionRouteGuard, DeliveryOptionsRouteGuard],
      },
      {
        path: "labelprint",
        component: ReturnComponent,
        canActivate: [CancelOriginalReturnRouteGuard, TechSupportRedirectGuard],
        resolve: { returnOrderResponse: ReturnOrderRouteResolver, techSupportResponse: TechSupportResolver },
      },
      {
        path: "labelgenerate",
        component: CustomerServiceCaseComponent,
        resolve: { techSupportResponse: TechSupportResolver },
      },
      {
        path: "error",
        component: SomethingWrongComponent,
      },
      {
        path: "globalerror",
        component: GlobalErrorComponent,
      }
    ],
  },
  {
    path: "m",
    component: MobileHomeComponent,
    canActivate: [MobileScreenRouteGuard],
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: TestHomeComponents,
        canActivate: [LandingPageRouteGuard],
      },
      {
        path: "login",
        component: LoginPageComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard],
      },
      {
        path: "welcome",
        component: LandingPageComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard],
      },
      {
        path: "additems",
        component: MAddItemComponent,
        canActivate: [],
      },
      {
        path: "shippingoption",
        component: DeliveryOptionsComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard, OrderSelectionRouteGuard],
      },
      {
        path: "updateaddress",
        component: UpdateAddressComponent,
      },
      {
        path: "itemselection",
        component: ReturnItemComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard],
      },
      {
        path: "returnconfirm",
        component: ConfirmReturnComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard, OrderSelectionRouteGuard, DeliveryOptionsRouteGuard],
      },
      {
        path: "labelprint",
        component: ReturnCreatedComponent,
        canActivate: [AppFlowRouteGuard, LabelCreatedRouteGuard, OrderSelectionRouteGuard, DeliveryOptionsRouteGuard],
        resolve: { returnOrderResponse: ReturnOrderRouteResolver },
      },
      {
        path: "error",
        component: SomethingWrongComponent,
      },
      {
        path: "globalerror",
        component: GlobalErrorComponent,
      }
    ],
  },
  {
    path: "notfound",
    component: NotFoundComponent,
  },
  { path: "**", redirectTo: "/notfound" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: "enabled" })],
  exports: [RouterModule],
  providers: [ReturnOrderRouteResolver,TechSupportResolver],
})
export class AppRoutingModule {
  constructor(private appFlowService: AppFlowService) {
    this.appFlowService.setAppFlowByName(clientConfig.APPFLOW);
    console.log("Setting aApp Flow route module", clientConfig.APPFLOW);
  }
}
